module.exports = __webpack_public_path__ + "img/Kong API Gateway Support by Micro Beaver for IT Solutions.35bf3a23.png";